import styles from './style.postcss';
import React from 'react';
import classnames from 'classnames';
import is from 'is_js';
import PropTypes from 'prop-types';
import { testClass } from 'omni-common-ui';

const ContentItem = (props) => {
  const classesBoard = classnames(
      styles.ContentItem_board,
      props.className,
      testClass('content-item'));

  return <div className={classesBoard}>
    <div className={styles.ContentItem_title}>
      {is.existy(props.homeworkType) ?
        <label className={styles.ContentItem_label}>{props.homeworkType}</label> :
        null}
      {is.existy(props.boardTitle) ?
        <h5 className={styles.ContentItem_h5}>{props.boardTitle}</h5> :
        null}
    </div>
    {is.existy(props.boardValue) ?
      <p className={styles.ContentItem_p}>{judgeValue(props.boardValue)}</p> :
      null}
  </div>;

  function judgeValue(boardValue) {
    if (! is.not.undefined(boardValue) || ! boardValue || boardValue === '') {
      return '_';
    }
    return boardValue;
  }
};

ContentItem.propTypes = {
  className: PropTypes.string,
  homeworkType: PropTypes.string,
  boardTitle: PropTypes.string.isRequired,
  boardValue: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default ContentItem;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/ContentItem/index.jsx